var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LogTimeButton',{attrs:{"button-classes":[
    _vm.buttonProps.class,
    'direction-right',
    { 'is-active': _vm.loggedTime !== '0h' } ],"icon":_vm.buttonProps.icon,"tooltip":_vm.buttonProps.tooltip},nativeOn:{"click":function($event){return _vm.timerToggle.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }